"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[616],{

/***/ 32184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInterval; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useInterval(callback, delay) {
    var deps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var intervalRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (delay === null || delay === 0) {
            if (intervalRef.current) {
                window.clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            return;
        }
        var tick = function() {
            return savedCallback.current();
        };
        if (typeof delay === "number") {
            intervalRef.current = window.setInterval(tick, delay);
            return function() {
                return window.clearInterval(intervalRef.current);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(deps).concat([
        delay
    ]));
    return intervalRef;
}


/***/ }),

/***/ 20525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TabComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/tabs/tab/tab-component.scss.js

var LINE_WIDTH = 4;
var LINE_WIDTH_STRING = "".concat(LINE_WIDTH, "px");
var StyledTabComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ergyzlu0"
})("position:relative;text-align:center;min-width:240px;cursor:pointer;padding:16px 24px;:hover{outline:0;background-color:var(--tab-background-color);.tab-label{color:var(--tab-color);}}&.active{background-color:var(--tab-background-color);.tab-underline-placeholder{background:var(--tab-background-color);.tab-underline{left:0;right:0;}}}&.small-labels{min-width:160px;.tab-label{font-size:0.875rem;}}&.half-screen-tabs{min-width:100px;display:flex;justify-content:center;padding:8px 5px;.title-wrapper{.title-and-icon-wrapper{.core-title-container .core-title{font-weight:300;}.icon-wrapper{.picture-icon-wrapper{height:20px;margin-bottom:4px;}}}}}.tab-label{font-weight:600;font-size:1.375rem;}.tab-underline-placeholder{position:absolute;height:", LINE_WIDTH_STRING, ";bottom:0;left:0;right:0;border-top-left-radius:", LINE_WIDTH_STRING, ";border-top-right-radius:", LINE_WIDTH_STRING, ";.tab-underline{position:absolute;top:0;bottom:0;left:50%;right:50%;transition:left 0.2s ease,right 0.2s ease;border-top-left-radius:", LINE_WIDTH_STRING, ";border-top-right-radius:", LINE_WIDTH_STRING, ";}}");

;// CONCATENATED MODULE: ./components/core/tabs/tab/tab-component.js






function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}











var TabComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TabComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TabComponent);
    function TabComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TabComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "blurTab", function(e) {
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".tab-component")) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "tabClickedAction", function() {
            var _props = _this.props, onClick = _props.onClick, index = _props.index, label = _props.label, labelTranslationKey = _props.labelTranslationKey, extraData = _props.extraData;
            BigBrain("track", bigbrain_event_types.TAB_CLICKED, {
                kind: label,
                info1: index,
                info2: labelTranslationKey,
                data: extraData
            });
            onClick(index);
        });
        _this.onTabClicked = _this.onTabClicked.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.tabClickedAction);
        return _this;
    }
    (0,_create_class/* default */.Z)(TabComponent, [
        {
            key: "onTabClicked",
            value: function onTabClicked(e) {
                this.blurTab(e);
                this.tabClickedAction();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, label = _props.label, hideLabel = _props.hideLabel, color = _props.color, backgroundColor = _props.backgroundColor, isActive = _props.isActive, useSmallLabels = _props.useSmallLabels, tabIcon = _props.tabIcon, useXSMLabels = _props.useXSMLabels, tabsWithIcons = _props.tabsWithIcons, tabClassName = _props.tabClassName, theme = _props.theme, unsetLabelColor = _props.unsetLabelColor;
                var tabColor = colors/* default */.Z[color];
                var tabLabel = hideLabel ? "" : label;
                var defaultTabLabelColor = (0,segments_service/* isDarkTheme */.$o)(theme) ? colors/* default */.Z[color_consts.WHITE_COLOR_NAME] : colors/* default.mud */.Z.mud;
                var tabLabelColor = isActive ? tabColor : defaultTabLabelColor;
                var unsetTabLabelcolor = function() {
                    return unsetLabelColor && (0,segments_service/* isDarkTheme */.$o)(theme) && !isActive;
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabComponent, {
                    className: classnames_default()("tab-component", (0,_define_property/* default */.Z)({
                        active: isActive,
                        "small-labels": useSmallLabels,
                        "half-screen-tabs": useXSMLabels
                    }, tabClassName, tabClassName)),
                    style: {
                        "--tab-color": tabColor,
                        "--tab-background-color": colors/* default */.Z[backgroundColor] || colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME]
                    },
                    onClick: this.onTabClicked,
                    role: "tab",
                    "aria-selected": isActive,
                    tabIndex: 0,
                    onKeyDown: this.onKeyDown,
                    children: [
                        !tabsWithIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tab-label",
                            style: unsetTabLabelcolor() ? {} : {
                                color: tabLabelColor
                            },
                            children: tabLabel
                        }),
                        tabsWithIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                title: tabLabel,
                                titleIcon: tabIcon === null || tabIcon === void 0 ? void 0 : tabIcon.src,
                                titleSize: sizes/* XS_L */.L4
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tab-underline-placeholder",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tab-underline",
                                style: {
                                    background: tabColor
                                }
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return TabComponent;
}(react.PureComponent);

TabComponent.defaultProps = {
    useSmallLabels: false
};


/***/ }),

/***/ 10873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./constants/query-params.js
var query_params = __webpack_require__(54224);
// EXTERNAL MODULE: ./client/services/hooks/use-interval.js
var use_interval = __webpack_require__(32184);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/tabs/tabs-component.scss.js

var StyledTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edmslg20"
})("display:flex;flex-direction:column;&.left{align-items:flex-start;}&.center{align-items:center;}&.right{align-items:flex-end;}.tabs{display:flex;width:100%;justify-content:space-around;}.content{padding-top:48px;}");

;// CONCATENATED MODULE: ./components/core/tabs/tabs-component.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










var TabsComponent = function(props) {
    var children = props.children, defaultActiveTabIndex = props.defaultActiveTabIndex, router = props.router, autoTransition = props.autoTransition, className = props.className, tabsAlign = props.tabsAlign, scrollSpeed = props.scrollSpeed, scrollOnTabClick = props.scrollOnTabClick, distanceFromTop = props.distanceFromTop, onTabClick = props.onTabClick;
    var getInitialActiveTabIndex = function() {
        try {
            var _router_asPath_split, _router_asPath;
            var params = querystring.parse(router === null || router === void 0 ? void 0 : (_router_asPath = router.asPath) === null || _router_asPath === void 0 ? void 0 : (_router_asPath_split = _router_asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[1]);
            var activeTabId = params === null || params === void 0 ? void 0 : params[query_params.ACTIVE_TAB_ID];
            if (activeTabId) {
                var activeTabIndexById = children === null || children === void 0 ? void 0 : children.findIndex(function(tab) {
                    var _tab_props;
                    return (tab === null || tab === void 0 ? void 0 : (_tab_props = tab.props) === null || _tab_props === void 0 ? void 0 : _tab_props.tabId) === activeTabId;
                });
                if (activeTabIndexById && activeTabIndexById >= 0) {
                    return activeTabIndexById;
                }
            }
        } catch (e) {
            return defaultActiveTabIndex;
        }
        return defaultActiveTabIndex;
    };
    var ref = (0,react.useState)(getInitialActiveTabIndex()), activeTabIndex = ref[0], setActiveTabIndex = ref[1];
    var contentNode = (0,react.useRef)();
    var autoTransitionAsNumber = Number(autoTransition || 0);
    (0,use_interval/* default */.Z)(function() {
        setActiveTabIndex((activeTabIndex + 1) % children.length);
    }, autoTransitionAsNumber > 0 ? autoTransitionAsNumber : null, [
        activeTabIndex
    ]);
    var handleTabClick = function() {
        var _ref = _async_to_generator(function(index) {
            var node, _tmp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        node = contentNode === null || contentNode === void 0 ? void 0 : contentNode.current;
                        if (onTabClick) {
                            onTabClick(index);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        _tmp = scrollOnTabClick && node;
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,dom_utils_service.isNodeFullyInView)(node)
                        ];
                    case 2:
                        _tmp = !_state.sent();
                        _state.label = 3;
                    case 3:
                        if (_tmp) {
                            (0,dom_utils_service.scrollTo)(contentNode.current.offsetTop - distanceFromTop, scrollSpeed);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setActiveTabIndex(index);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTabClick(index) {
            return _ref.apply(this, arguments);
        };
    }();
    var tabsRenderer = function() {
        return children.map(function(child, index) {
            return /*#__PURE__*/ (0,react.cloneElement)(child, {
                onClick: handleTabClick,
                index: index,
                isActive: index === activeTabIndex
            });
        });
    };
    var contentRenderer = function() {
        if (children[activeTabIndex]) {
            return children[activeTabIndex].props.children;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabsComponent, {
        className: classnames_default()("tabs-component", className, tabsAlign),
        ref: contentNode,
        role: "tablist",
        "aria-label": "documentation-navigation",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tabs",
                style: {
                    "--tab-transition": autoTransition
                },
                children: tabsRenderer()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content",
                role: "tab",
                children: contentRenderer()
            })
        ]
    });
};
/* harmony default export */ var tabs_component = ((0,router.withRouter)(TabsComponent));
TabsComponent.defaultProps = {
    children: [],
    defaultActiveTabIndex: 0,
    autoTransition: "30000",
    scrollSpeed: 200,
    scrollOnTabClick: false,
    distanceFromTop: 0,
    className: "",
    tabsAlign: align_types.ALIGN_TYPES.CENTER
};


/***/ }),

/***/ 60616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ side_by_side_tabs_and_process_tabs_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-desktop/side-by-side-tabs-and-process-tabs-desktop-component.scss.js


var StyledSideBySideTabsAndProcessTabsDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezbwsux0"
})("max-width:", "".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px"), ";margin:auto;.process-tabs{width:100%;}.vertical-timer-tabs-container{gap:64px;.vertical-timer-tab-desktop-container{.vertical-timer-tab-desktop-title-button{span{font-weight:600;}}}.desktop-tabs-text-container{&.tabs-container{max-width:350px;min-width:300px;justify-content:flex-start;margin-top:16px;}}}.main-title{text-align:center;font-weight:600;}");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/tabs/tabs-component.js + 1 modules
var tabs_component = __webpack_require__(10873);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs-desktop/process-tabs-desktop.scss.js

var PROCESS_INDICATOR_DIAMETER = "9px";
var StyledProcessTabsDesktop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezp74iy0"
})('.process-tab{flex:1;min-width:fit-content;text-align:left;padding-left:0;:hover{background-color:transparent;.tab-label{opacity:0.7;color:var(--tab-color);transition:color 0.15s ease;}}&.active{.tab-label{font-weight:600;}background-color:transparent;.tab-underline-placeholder{background:transparent;.tab-underline::after{content:"";position:absolute;width:100%;height:100%;top:-1px;bottom:-4px;background-color:var(--tab-color);left:0;right:0;border-top-left-radius:0;border-top-right-radius:0;animation:', "fill-progress-bar calc(var(--tab-transition) * 1ms) cubic-bezier(0.4, 0, 0.8, 1) forwards", ";}.tab-underline::before{background-color:var(--tab-color);}}}.tab-label{font-weight:initial;color:unset;font-size:1rem;}.tab-underline-placeholder{height:1px;display:flex;align-items:center;.tab-underline{background-color:var(--tab-color);left:0;right:0;border-top-left-radius:0;border-top-right-radius:0;}}&.process-indicator{.tab-underline-placeholder{.tab-underline{left:", PROCESS_INDICATOR_DIAMETER, ';}}.tab-underline::before{content:"";display:block;width:', PROCESS_INDICATOR_DIAMETER, ";height:", PROCESS_INDICATOR_DIAMETER, ";border-radius:50%;background-color:transparent;border:1px solid var(--tab-color);position:relative;top:50%;left:-", PROCESS_INDICATOR_DIAMETER, ";transform:translateY(-50%);}}}.asset-and-text{.asset-title{text-align:center;}}@keyframes fill-progress-bar{from{width:0%;}to{width:100%;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs-desktop/process-tabs-desktop.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}








var ProcessTabsDesktop = function(param) {
    var tabs = param.tabs, tabsColor = param.tabsColor, activeTabId = param.activeTabId, distanceFromTop = param.distanceFromTop, autoTransition = param.autoTransition, scrollSpeed = param.scrollSpeed, scrollOnTabClick = param.scrollOnTabClick, showProcessIndicator = param.showProcessIndicator, titleConfig = param.titleConfig;
    var ref = (0,react.useState)(true), isAutoTransition = ref[0], setIsAutoTransition = ref[1];
    var renderedTabs = (0,react.useMemo)(function() {
        return tabs.map(function(tab, index) {
            var tabLabel = tab.tabLabel, tabId = tab.tabId, asset = tab.asset, title = tab.title;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                tabClassName: classnames_default()("process-tab", {
                    "process-indicator": showProcessIndicator
                }),
                tabId: tabId,
                label: tabLabel,
                color: tabsColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "asset-and-text",
                    children: [
                        asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, asset)),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, _object_spread({
                            titleClassName: "asset-title"
                        }, title, titleConfig))
                    ]
                })
            }, index);
        });
    }, [
        showProcessIndicator,
        tabs,
        tabsColor,
        titleConfig
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProcessTabsDesktop, {
        className: "process-tabs-desktop",
        onMouseLeave: function() {
            return setIsAutoTransition(true);
        },
        onMouseEnter: function() {
            return setIsAutoTransition(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_component/* default */.Z, {
            autoTransition: isAutoTransition ? autoTransition : null,
            scrollOnTabClick: scrollOnTabClick,
            scrollSpeed: scrollSpeed,
            distanceFromTop: distanceFromTop,
            activeTabId: activeTabId,
            role: "tabpanel",
            children: renderedTabs
        })
    });
};
/* harmony default export */ var process_tabs_desktop = (ProcessTabsDesktop);

// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-component.js + 2 modules
var use_cases_tabs_component = __webpack_require__(93012);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs-mobile/process-tabs-mobile.scss.js

var process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER = "5px";
var PROCESS_MARGIN = "8px";
var StyledProcessTabsMobile = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1en5vok0"
})('.mobile-wrapper{.use-cases-tabs-mobile-component{.mobile-tabs-component{.asset-title{font-size:1rem;}.mobile-tabs-navigation{padding-left:0;.tab-nav-button-wrapper{padding-bottom:20px;.tab-nav-button{min-width:64px;position:relative;background-color:transparent;color:inherit;border-radius:none;padding-left:0;padding-bottom:0;&::before{position:absolute;content:"";display:flex;width:', process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, ";height:", process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, ";border-radius:50%;background-color:transparent;border:1px solid var(--tab-color);position:relative;top:100%;top:", "calc(100% + ".concat(PROCESS_MARGIN, ")"), ';left:0;}&::after{content:"";position:absolute;display:flex;left:calc(', process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, " + ", process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, " / 2);top:calc(100% + ", process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, " / 2 + 1px + ", PROCESS_MARGIN, ");width:100%;background-color:var(--tab-color);height:1px;}&.selected{color:var(--tab-color);&::before{background-color:var(--tab-color);}}}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs-mobile/process-tabs-mobile.js
function process_tabs_mobile_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function process_tabs_mobile_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            process_tabs_mobile_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var ProcessTabsMobile = function(param) {
    var tabs = param.tabs, tabsColor = param.tabsColor, autoTransition = param.autoTransition, titleConfig = param.titleConfig, tabBackgroundColor = param.tabBackgroundColor;
    var getTabAssetFullParagraph = (0,react.useCallback)(function(tab) {
        return _object_spread_props(process_tabs_mobile_object_spread(_object_spread_props(process_tabs_mobile_object_spread({}, tab.title || {
            title: ""
        }), {
            topic: {},
            body: null
        }), titleConfig), {
            titleClassName: "asset-title"
        });
    }, [
        titleConfig
    ]);
    var mobileTabs = (0,react.useMemo)(function() {
        return tabs.map(function(tab) {
            return {
                tabLabel: tab.tabLabel,
                tabContent: {
                    asset: null,
                    mobileAsset: tab.asset,
                    images: [
                        {
                            src: null,
                            fullParagraph: getTabAssetFullParagraph(tab)
                        }
                    ]
                }
            };
        });
    }, [
        getTabAssetFullParagraph,
        tabs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProcessTabsMobile, {
        className: "process-tabs-mobile",
        style: {
            "--tab-color": colors/* default */.Z[tabsColor],
            backgroundColor: tabBackgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(use_cases_tabs_component["default"], {
            tabs: mobileTabs,
            autoplaySpeed: autoTransition
        })
    });
};
/* harmony default export */ var process_tabs_mobile = (ProcessTabsMobile);

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/default-props.js
function default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}
function default_props_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function default_props_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        default_props_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var default_props = (default_props_object_spread_props(default_props_object_spread({}, tabs_component/* default.defaultProps */.Z.defaultProps), {
    tabsColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
    showProcessIndicator: true,
    tabs: [
        {
            tabLabel: "Clients Projects",
            asset: {
                image: default_props_object_spread_props(default_props_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps.asset.image), {
                    src: "/static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
                }),
                position: "center"
            },
            title: {
                titleSize: sizes/* XS_M */.g4,
                title: null
            }
        },
        {
            tabLabel: "Content Planning",
            asset: {
                image: default_props_object_spread_props(default_props_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps.asset.image), {
                    src: "/static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
                }),
                position: "center"
            },
            title: {
                titleSize: sizes/* XS_M */.g4,
                title: null
            }
        }
    ]
}));

;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs.js




var ProcessTabs = (0,responsive_hoc_component/* default */.Z)(process_tabs_desktop, process_tabs_mobile);
/* harmony default export */ var process_tabs = (ProcessTabs);
ProcessTabs.defaultProps = default_props;

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs.js + 5 modules
var vertical_timer_tabs = __webpack_require__(34864);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs.js
function side_by_side_tabs_and_process_tabs_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_process_tabs_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_process_tabs_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_tabs_and_process_tabs_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_tabs_and_process_tabs_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var DEFAULT_TAB_CONTENT = {
    topic: {},
    title: null
};
var SideBySideTabsAndProcessTabs = function(_param) {
    var tabContent = _param.tabContent, title = _param.title, advancedTitleConfig = _param.advancedTitleConfig, advancedProcessTabs = _param.advancedProcessTabs, rest = _object_without_properties(_param, [
        "tabContent",
        "title",
        "advancedTitleConfig",
        "advancedProcessTabs"
    ]);
    var contentRenderer = function(contentObject) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, side_by_side_tabs_and_process_tabs_object_spread_props(side_by_side_tabs_and_process_tabs_object_spread({}, DEFAULT_TAB_CONTENT, contentObject, tabContent), {
            titleSize: sizes.XS
        }));
    };
    var processRenderer = function(param) {
        var processTab = param.processTab;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "process-tabs",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(process_tabs, side_by_side_tabs_and_process_tabs_object_spread({}, processTab, advancedProcessTabs))
        });
    };
    var titleMargin = title.titleMargin, titleProps = _object_without_properties(title, [
        "titleMargin"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "side-by-side-tabs-and-process-tabs-component",
        children: [
            (titleProps === null || titleProps === void 0 ? void 0 : titleProps.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title-wrapper",
                style: {
                    marginBottom: titleMargin
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, side_by_side_tabs_and_process_tabs_object_spread({
                    titleClassName: "main-title"
                }, titleProps))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vertical_timer_tabs/* default */.Z, side_by_side_tabs_and_process_tabs_object_spread_props(side_by_side_tabs_and_process_tabs_object_spread({}, rest), {
                title: advancedTitleConfig,
                tabContentRenderer: contentRenderer,
                rightSideRenderer: processRenderer,
                tabsContainerClassName: "tabs-container"
            }))
        ]
    });
};
/* harmony default export */ var side_by_side_tabs_and_process_tabs = (SideBySideTabsAndProcessTabs);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-desktop/side-by-side-tabs-and-process-tabs-desktop-component.js
function side_by_side_tabs_and_process_tabs_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_process_tabs_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_process_tabs_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}



var SideBySideTabsAndProcessTabsDesktopComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideTabsAndProcessTabsDesktopComponent, {
        className: "side-by-side-tabs-and-process-tabs-desktop-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_tabs_and_process_tabs, side_by_side_tabs_and_process_tabs_desktop_component_object_spread({}, props))
    });
};
/* harmony default export */ var side_by_side_tabs_and_process_tabs_desktop_component = (SideBySideTabsAndProcessTabsDesktopComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-mobile/side-by-side-tabs-and-process-tabs-component.scss.js


var TAB_CONTENT_PADDING = "40px";
var StyledSideBySideTabsAndProcessTabsMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yon0yy0"
})(".mobile-wrapper{.mobile-timer-tabs-component{padding:0;.vertical-timer-tab-mobile-component{padding:0 ", TAB_CONTENT_PADDING, ';&:after{content:"";position:absolute;left:0;display:block;height:1px;width:100%;background-color:', colors/* default.asphalt */.Z.asphalt, ";}.vertical-timer-tab-mobile-content-container{padding-bottom:20px;}.vertical-timer-tab-mobile-title{padding-top:44px;padding-bottom:8px;}&:has(> div.vertical-timer-tab-mobile-title-selected){background-color:var(--selected-tab-background-color);}.process-tabs{.mobile-wrapper{.use-cases-tabs-mobile-component{.mobile-tabs-component{.mobile-tabs-navigation{margin-right:-", TAB_CONTENT_PADDING, ";padding-left:0;}}}}}.vertical-timer-tab-mobile-content{.paragraph-wrapper .paragraph-body{font-size:1rem;margin-bottom:24px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-mobile/side-by-side-tabs-and-process-tabs-mobile-component.js
function side_by_side_tabs_and_process_tabs_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_process_tabs_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_process_tabs_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_mobile_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_tabs_and_process_tabs_mobile_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_mobile_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var SideBySideTabsAndProcessTabsMobileComponent = function(_param) {
    var selectedTabBackgroundColor = _param.selectedTabBackgroundColor, rest = side_by_side_tabs_and_process_tabs_mobile_component_object_without_properties(_param, [
        "selectedTabBackgroundColor"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideTabsAndProcessTabsMobileComponent, {
        className: "side-by-side-tabs-and-process-tabs-mobile-component",
        style: {
            "--selected-tab-background-color": colors/* default */.Z[selectedTabBackgroundColor]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_tabs_and_process_tabs, side_by_side_tabs_and_process_tabs_mobile_component_object_spread({}, rest))
    });
};
/* harmony default export */ var side_by_side_tabs_and_process_tabs_mobile_component = (SideBySideTabsAndProcessTabsMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/deafult-props.js

/* harmony default export */ var deafult_props = ({
    maxLimit: 4,
    showDivider: true,
    title: {
        title: "Built for any kind of work process"
    },
    titleMargin: "50px",
    tabs: [
        {
            title: "For leadership",
            content: {
                topic: {},
                title: null,
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            processTab: default_props
        },
        {
            title: "For managers",
            content: {
                topic: {},
                title: null,
                body: "Gain greater visibility and transparency over the work being done with robust dashboards and project overviews of where initiatives stand."
            },
            processTab: default_props
        },
        {
            title: "For teams and individuals",
            content: {
                topic: {},
                title: null,
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            processTab: default_props
        }
    ],
    advancedProcessTabs: {
        defaultActiveTabIndex: 0,
        autoTransition: 30000,
        scrollOnTabClick: false,
        distanceFromTop: 0
    },
    timerEnabled: false,
    showButton: false,
    arrowSize: "12px",
    showArrow: true
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-component.js




var SideBySideTabsAndProcessTabsComponent = (0,responsive_hoc_component/* default */.Z)(side_by_side_tabs_and_process_tabs_desktop_component, side_by_side_tabs_and_process_tabs_mobile_component);
/* harmony default export */ var side_by_side_tabs_and_process_tabs_component = (SideBySideTabsAndProcessTabsComponent);
SideBySideTabsAndProcessTabsComponent.defaultProps = deafult_props;


/***/ }),

/***/ 38305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65832);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91841);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
    textSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
    assetQuality: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_2__.AUTO,
    nestedBoardItems: {
        //props that are relevant only if the live board experience is added
        addLiveBoardTextAndAsset: false,
        boardBannerText: "Sign up for free to gain full access to all features",
        embeddedBoardTitle: "Project plan",
        addSecondLiveBoardSignUpButton: false
    }
}));


/***/ }),

/***/ 8150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SideBySideTextAndAssetComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_side_by_side_text_and_asset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59526);
/* harmony import */ var _default_props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38305);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var SideBySideTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent);
    function SideBySideTextAndAssetComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, SideBySideTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "side-by-side-text-and-asset-component",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(segments_desktop_core_components_side_by_side_text_and_asset_side_by_side_text_and_asset__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return SideBySideTextAndAssetComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

SideBySideTextAndAssetComponent.defaultProps = _default_props__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;


/***/ })

}]);